import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import ddt from '@wix/da-ddt';
import { setCookieAccepted, setCookieSettings } from '../../publicSession/actions';
/**
 * GAM CMP / IAB hook
 *
 */ export function useGAMInit({ adsEnabled }) {
    const dispatch = useDispatch();
    useEffect(()=>{
        if (!adsEnabled || typeof window === 'undefined') {
            return;
        }
        let isInitialized = false;
        // We need to wait for the GAM library to be loaded
        window['googletag'] = window['googletag'] || {
            cmd: []
        };
        window['googletag'].cmd.push(function() {
            // We need to wait for the GAM to initialize the ad slots
            // which then adds IAB __tcfapi support
            window['googletag'].pubads().addEventListener('slotRequested', function(event) {
                if (typeof window['__tcfapi'] === 'undefined') {
                    return;
                }
                // We only want this to run once due multiple slots requested on the page
                if (isInitialized) {
                    return;
                }
                isInitialized = true;
                window['__tcfapi']('addEventListener', 2, (tcData, success)=>{
                    // only listen to the submit event
                    if (tcData.eventStatus !== 'useractioncomplete') {
                        return;
                    }
                    ddt.log('ads', 'CMP: useractioncomplete', tcData);
                    dispatch(setCookieSettings({
                        analytics: tcData.publisher.legitimateInterests[8],
                        functional: tcData.publisher.consents[1],
                        marketing: tcData.publisher.legitimateInterests[9]
                    }));
                    dispatch(setCookieAccepted());
                });
            });
        });
    // We only want this to run once
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}
